export function getDescriptions(ebi) {
  return {
    insDesc: ebi.insuranceTypeDescription,
    planDesc: ebi.planCoverageDescription,
    covDesc: ebi.coverageLevelDescription,
  };
}
